import { createAsyncThunk } from '@reduxjs/toolkit';
import { IState } from '../..';
import { httpService } from '../../..';
import { executeApiRequest } from '../../asyncUtils';
import { filesActionCreators } from '../../files';
import { showFailedRequestDialogThunk } from '../../thunkUtils';
import { uiActionCreators } from '../../ui';

export const generatePaperwork = createAsyncThunk<void, { loadNumber: string }, { state: IState }>(
  'logistics/uploadToAzure',
  async ({ loadNumber }: { loadNumber: string }, { dispatch, getState, rejectWithValue }) => {
    dispatch(uiActionCreators.showSpinnerDialog());

    const response = await executeApiRequest(
      () => httpService.post(`/Logistics/Loads/${loadNumber}/GeneratePaperwork`),
      false
    );

    if (response.requestFailed) {
      showFailedRequestDialogThunk(response, getState(), dispatch);
      rejectWithValue(response.exception?.message);
    } else {
      dispatch(filesActionCreators.fetchFiles({ container: 'logisticsfiles', folder: `loads/${loadNumber}` }));
    }

    dispatch(uiActionCreators.hideSpinnerDialog());
  }
);
